var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contents"},[_c('tab-menu',{attrs:{"menu-list":_vm.menuList}}),(_vm.pageName === 'InquiriesType')?_c('mall-selector',{attrs:{"sortByCreation":true}}):_vm._e(),_c('router-view',{staticClass:"content-top"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }